import { ref } from 'vue'

export interface UseClipboardOptions {
    successDuration?: number
    onSuccess?: () => void
    onError?: (error: unknown) => void
}

export function useClipboard(options: UseClipboardOptions = {}) {
    const copied = ref(false)
    const { successDuration = 2000, onSuccess, onError } = options
    const copyToClipboard = async (text: string, logSuccess?: () => void): Promise<boolean> => {
        if (!text) {
            return false
        }

        try {
            await navigator.clipboard.writeText(text)
            copied.value = true
            setTimeout(() => {
                copied.value = false
                logSuccess?.()
                onSuccess?.()
            }, successDuration)
            return true
        } catch (error) {
            console.error('Failed to copy link:', error)
            onError?.(error)
            return false
        }
    }

    return { copied, copyToClipboard }
}
